module.exports = __webpack_public_path__ + "static/media/view1.7df9a683.jpg";